<app-base-modal
  [title]="'Покупатель'"
  [showStateToggle]="hasCustomer"
>
  @if (isLoading) {
    <app-loader/>
  }
  @if (hasCustomer) {
    <app-current-customer-modal
      [customerFormGroup]="customerFormGroup"
      [customerDialogData]="customerDialogData"
      [isEditModeActive]="isEditModeActive"
      (detachCustomer)="attachOrDetachCustomer(null)"
      (updateLoading)="updateLoading($event)"
    />
  } @else {
    <app-new-customer-modal
      [customerFormGroup]="customerFormGroup"
      [customerDialogData]="customerDialogData"
      (attachCustomer)="attachOrDetachCustomer($event)"
      (closeDialog)="closeDialog($event)"
      (updateLoading)="updateLoading($event)"
    />
  }
</app-base-modal>
